<template>
    <div id="modal-orders-sales-orders-show-customer-card">
        <b-modal :id="modalName" title="Customer Card: " scrollable hide-footer size="lg">
            <template v-slot:modal-title>
                Customer Card:
            </template>

            <b-container fluid>
                <b-table-simple hover small fixed bordered>
                    <b-thead>
                        <b-th class="default-card"></b-th>
                        <b-th>Number</b-th>
                        <b-th>Exp</b-th>
                        <b-th>CVC</b-th>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(card, index) in lists.cards" :key="index">
                            <b-td :class="{ 'highlight-green': card.default }" />
                            <b-td>
                                <b-form-input v-if="$can('view-customer-detail-payment-method') || $can('view-all')" :id="'input-cards-number' + card.id" :value="formatCard(card.number, 'full')" type="text" placeholder="" size="sm" autocomplete="off" disabled />
                                <b-form-input v-else :id="'input-cards-number' + card.id" :value="formatCard(card.number, 'partial')" type="text" placeholder="" size="sm" autocomplete="off" disabled />
                            </b-td>
                            <b-td>
                                <b-form-input :id="'input-cards-exp' + card.id" :value="card.exp" type="text" placeholder="" size="sm"
                                    autocomplete="off" disabled />
                            </b-td>
                            <b-td>
                                <b-form-input :id="'input-cards-cvc' + card.id" :value="card.cvc" type="text" placeholder="" size="sm"
                                    autocomplete="off" disabled />
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: [
        'customerId'
    ],

    components: {

    },

    data() {
        return {
            modalName: 'modal-orders-sales-orders-show-customer-card',

            lists: {
                cards: []
            }
        }
    },

    methods: {
        formatCard(card, show) {
            let cardNumber = ''
            if (show == 'partial') {
                cardNumber = 'XXXX' + card.substring(card.length - 4)
            } else {
                cardNumber = card
            }

            return cardNumber
        },

        getCustomerCards() {
            let url = 'api/lists/customers/getcards/' + this.customerId
            axios.get(url, {})
                .then((res) => {
                    this.lists.cards = res.data.cards
                }, () => {
                    this.has_error = true
                })
        }
    },

    computed: {

    },

    mounted() {
        this.getCustomerCards()
    }
}
</script>
<style lang="scss">
#modal-orders-sales-orders-show-customer-card {
    // .modal-dialog {
    //     width: 190px !important;
    // }

    .modal-content {
        .default-card {
            width: 1px;
        }

        .highlight-green {
            background-color: green;
        }
    }
}
</style>
